import React, { useState, useEffect } from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import Radio from '@material-ui/core/Radio';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormGroup from '@material-ui/core/FormGroup';
import RadioGroup from '@material-ui/core/RadioGroup';

export default function PreguntaMultiselect({
  textoPregunta,
  PreguntasOpciones,
  valorDefault = [],
  numeroPregunta,
  onChangeRespuesta,
  isHorizontal,
  esObligatoria,
  seleccionUnica = false // 🔸 Prop para determinar el tipo de selección
}) {
  const [selectedValues, setSelectedValues] = useState(Array.isArray(valorDefault) ? valorDefault : []);

  // Sincroniza con el valorDefault si cambia
  useEffect(() => {
    const nuevoValor = Array.isArray(valorDefault) ? valorDefault : [];
    const idsSeleccionados = selectedValues.map((item) => item[0]);
    const idsDefault = nuevoValor.map((item) => item[0]);

    const sonIguales =
      idsSeleccionados.length === idsDefault.length && idsSeleccionados.every((id) => idsDefault.includes(id));

    if (!sonIguales) {
      setSelectedValues(nuevoValor);
    }
  }, [valorDefault]);

  const handleCheckboxChange = (event, opcion) => {
    const value = [opcion.id, opcion.opcion];
    setSelectedValues((prevSelected) =>
      prevSelected.some((item) => item[0] === opcion.id)
        ? prevSelected.filter((item) => item[0] !== opcion.id)
        : [...prevSelected, value]
    );
  };

  const handleRadioChange = (event) => {
    const idSeleccionado = parseInt(event.target.value);
    const opcion = PreguntasOpciones.find((o) => o.id === idSeleccionado);
    if (opcion) {
      setSelectedValues([[opcion.id, opcion.opcion]]);
    }
  };

  useEffect(() => {
    const respuesta = {
      numeroPregunta,
      tieneContenido: selectedValues.length > 0,
      contenido: selectedValues,
      esObligatoria
    };
    onChangeRespuesta(respuesta);
  }, [selectedValues]);

  return (
    <div>
      <div>{textoPregunta}</div>
      <FormControl component="fieldset">
        {seleccionUnica ? (
          <RadioGroup row={isHorizontal} value={selectedValues[0]?.[0] ?? ''} onChange={handleRadioChange}>
            {PreguntasOpciones.map((opcion) => (
              <FormControlLabel
                key={opcion.id}
                value={opcion.id}
                control={<Radio style={{ color: '#f1a208' }} />}
                label={opcion.opcion}
              />
            ))}
          </RadioGroup>
        ) : (
          <FormGroup row={isHorizontal}>
            {PreguntasOpciones.map((opcion) => (
              <FormControlLabel
                key={opcion.id}
                control={
                  <Checkbox
                    checked={selectedValues.some((item) => item[0] === opcion.id)}
                    onChange={(event) => handleCheckboxChange(event, opcion)}
                    style={{ color: '#f1a208' }}
                  />
                }
                label={opcion.opcion}
              />
            ))}
          </FormGroup>
        )}
      </FormControl>
      <div>
        <br />
      </div>
    </div>
  );
}
